import React, { useState, useCallback } from 'react'
import Head from 'next/head'
import Link from 'next/link'
import { Segment, Container, Header, Modal } from 'semantic-ui-react'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import Gallery from 'react-photo-gallery'
//import Carousel, { Modal, ModalGateway } from 'react-images'

import Layout from 'components/Layout'

const Factory = () => {
  const images = [21, 22, 23, 24, 25, 42, 26, 33, 27, 41, 40, 28, 29, 30, 31, 32, 51, 52, 54, 55]
  const photos = images.map((item) => ({
    src: `/img/factory/photo_${item}th.jpg`,
    width: 360,
    height: 270,
  }))

  const [currentImage, setCurrentImage] = useState(0)
  const [viewerIsOpen, setViewerIsOpen] = useState(false)

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index)
    setViewerIsOpen(true)
  }, [])

  const closeLightbox = () => {
    setCurrentImage(0)
    setViewerIsOpen(false)
  }

  return (
    <>
      <Head>
        <title>Собственное производство бревна и поломатериала - Аврора Хоумс</title>
        <meta
          property="og:title"
          content="Собственное производство бревна и поломатериала - Аврора Хоумс"
        />
        <meta
          name="description"
          content="Производство пиломатериала, бревна и домокомплектов. Мы знаем о дереве всё."
        />
        <meta
          property="og:description"
          content="Производство пиломатериала, бревна и домокомплектов. Мы знаем о дереве всё."
        />
        <meta
          property="og:image"
          content={`/_next/image?url=${encodeURIComponent(
            '/img/projects/5/plane/5.jpg'
          )}&w=640&q=75`}
        />
      </Head>
      <Layout>
        <Segment style={{ padding: '2em 0em' }} vertical>
          <Container text>
            <Header as="h2">Собственное производство</Header>
            <p>
              Покупая пиломатериалы у производителя вы получаете контроль качества на каждом этапе
              производства, а так же гарантию соответствия заявленным характеристикам.
            </p>
            <Header as="h2">Оборудование</Header>
            <p>
              <ul>
                <li>
                  Для производства бревна мы используем оцилиндровочный станок проходного типа
                  “Термит-280У”, благодаря уникальному способу фрезерования продольного паза
                  обеспечивается его идеальная геометрия и исключается проворачивание бревна в
                  станке.
                </li>
                <li>
                  Благодаря использованию дисковой угловой пилорамы “Гризли” достигается идеальная
                  геометрия экспортного качества, точность распила ±0,5 мм на 6000мм изделия.
                </li>
                <li>
                  Мы используем итальянский автоматизированный сушильный комплекс “Incoplan”, что
                  позволяет тщательно контролировать весь процесс сушки при высокой
                  производительности.
                </li>
              </ul>
            </p>
          </Container>

          <Container>
            <Gallery photos={photos} onClick={openLightbox} />
            <Modal basic open={viewerIsOpen} onClose={closeLightbox} size="large">
              <ImageGallery
                items={images.map((item) => ({
                  original: `/img/factory/photo_${item}.jpg`,
                  thumbnail: `/img/factory/photo_${item}th.jpg`,
                }))}
                showThumbnails={false}
                showFullscreenButton={false}
                showPlayButton={false}
                startIndex={currentImage}
              />
            </Modal>
          </Container>
        </Segment>
      </Layout>
    </>
  )
}

export default Factory
